export function Pagination({
  page,
  pageCount,
  onPage,
}: {
  page: number;
  pageCount: number;
  onPage: (p: number) => void;
}) {
  if (pageCount <= 1) return null;

  const btn =
    'px-2 py-1 rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed';

  return (
    <div className="flex items-center justify-between text-xs text-gray-500 mt-2">
      <button
        type="button"
        className={btn}
        disabled={page <= 0}
        onClick={() => onPage(page - 1)}
      >
        &lsaquo; Prev
      </button>
      <span>
        Page {page + 1} of {pageCount}
      </span>
      <button
        type="button"
        className={btn}
        disabled={page >= pageCount - 1}
        onClick={() => onPage(page + 1)}
      >
        Next &rsaquo;
      </button>
    </div>
  );
}
